import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';

const HRPage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const hrTools = [
    {
      title: 'HR Management',
      description: 'Manage users and their holidays and personal documents',
      icon: '👥',
      path: '/hr/management'
    },
    {
      title: 'CV Bank',
      description: 'Manage candidate profiles and CVs for recruitment',
      icon: '📄',
      path: '/hr/cv-bank'
    },
    {
      title: 'Employee Documents',
      description: 'Secure storage for employee documents',
      icon: '📁',
      path: '/hr/documents'
    }
  ];

  return (
    <Box>
      {/* HR Tools Navigation */}
      <Box
        sx={{
          mb: 4,
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <Grid container spacing={2}>
          {hrTools.map((tool) => (
            <Grid item xs={12} sm={6} md={4} key={tool.title}>
              <Card
                sx={{
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  border: 1,
                  borderColor: alpha(theme.palette.divider, 0.2),
                  backgroundColor: 'background.paper',
                  boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`,
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 12px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
                    borderColor: theme.palette.primary.main
                  },
                }}
                onClick={() => navigate(tool.path)}
              >
                <CardContent sx={{
                  textAlign: 'center',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 2
                }}>
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      bgcolor: alpha(theme.palette.primary.main, 0.1),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '2rem',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {tool.icon}
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 600,
                        fontSize: '1.1rem',
                        mb: 1,
                      }}
                    >
                      {tool.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        lineHeight: 1.4,
                      }}
                    >
                      {tool.description}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default HRPage;